export const PREORDERS_PAGE = '/v2/carrier-preorders/page';
export const PREORDERS_SUMMARY = '/v2/carrier-preorders/summary';
export const TRAILER_VOLUME_TYPES = '/v1/trailer-volume-types/trailer-volume-types/';
export const VAT_RATE_TYPES = '/v2/vat-rate-types/';
